import { setSeverity } from 'helper/setSeverity';
import { flattenV2Deviations } from 'helper/vehicleV2';

import type { SearchedVehicle } from './types';

import { DeviationState, type VehicleV2 } from 'API';

export const parseSearchedVehicles = (vehicles: VehicleV2[] | undefined): SearchedVehicle[] | undefined => {
    if (!vehicles) {
        return;
    }

    const parsedVehicles = vehicles.map(vehicle => ({
        name: vehicle.name,
        licensePlate: vehicle?.licensePlate,
        vin: vehicle.vin,
        connectivityStatus: vehicle.connectivityStatus?.value
            ? {
                  state: vehicle.connectivityStatus.value.state,
                  expectedDisconnect: vehicle.connectivityStatus.value.expectDisconnection,
              }
            : null,
        severity: setSeverity(flattenV2Deviations(vehicle.deviations).filter(d => d.state !== DeviationState.RESOLVED)),
    }));

    return parsedVehicles;
};
